export default "__VITE_ASSET__31f3b7c9__"